import React, { createContext, useState } from 'react';

const initialState: UserProfile = {
  user: {
    signedIn: false,
    greeting: '',
    basket: { items: 0 },
    shopperId: '',
    notifications: { hasNotification: false },
  },
};

type UserContextValue = {
  userState: UserProfile;
  updateUserState: React.Dispatch<React.SetStateAction<UserProfile>>;
};

const defaultUserContext: UserContextValue = {
  userState: initialState,
  updateUserState: () => {},
};

export const UserContext = createContext(defaultUserContext);

export const UserContextProvider = (props: { children: React.ReactNode }) => {
  const [userState, updateUserState] = useState(initialState);

  return (
    <UserContext.Provider value={{ userState, updateUserState }}>
      {props.children}
    </UserContext.Provider>
  );
};
